import React, { useState, useEffect} from "react";
import {
  Col,
  Card,
  Table,
  Dropdown,
  Spinner,
} from "react-bootstrap";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import swal from "sweetalert";
import Baseurl from "../../../Baseurl";
import { useHistory } from "react-router-dom";
function Taxes() {
  const history=useHistory();
  const [taxes, setTaxes] = useState([]);
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [state, setState] = useState("");
  const [addVehicleStatus, setAddVehicleStatus] = useState(false);
  const [deleteStatus, setDeleteStatus] = useState(false);
  const [deleteTax, setDeleteTax] = useState(false);
  const [vehicleName, setVehicleName] = useState("");
  const [taxId, setTaxId] = useState("");
  const [vehicleTax, setVehicleTax] = useState();
  const [vehicleTypeId, setVehicleTypeId] = useState("");
  const [vehicleObject, setVehicleObject] = useState([]);
  const [spinner, setSpinner] = useState(true);
  const handleClose = () => setShow(false);
  const vehicle = [
    "Bike",
    "3 Wheeler",
    "Auto",
    "SUV/MUV",
    "Sedan",
    "Hatch Back",
    "Tata Ace",
    "PickUp 8ft",
    "Tata 407",
  ];

  const states = [
    {
      id: 1,
      name: "Andhra Pradesh",
      path: "andhra-pradesh",
    },
    {
      id: 2,
      name: "Arunachal Pradesh",
      path: "arunachal-pradesh",
    },
    {
      id: 3,
      name: "Assam",
      path: "assam",
    },
    {
      id: 4,
      name: "Bihar",
      path: "bihar",
    },
    {
      id: 5,
      name: "Chhattisgarh",
      path: "chattisgarh",
    },
    {
      id: 6,
      name: "Delhi",
      path: "delhi",
    },

    {
      id: 7,
      name: "Goa",
      path: "goa",
    },
    {
      id: 8,
      name: "Gujarat",
      path: "gujrat",
    },
    {
      id: 9,
      name: "Haryana",
      path: "haryana",
    },
    {
      id: 10,
      name: "Himachal Pradesh",
      path: "himachal-pradesh",
    },
    {
      id: 11,
      name: "Jharkhand",
      path: "jharkhand",
    },
    {
      id: 12,
      name: "Karnataka",
      path: "Karnataka",
    },
    {
      id: 13,
      name: "Kerala",
      path: "kerala",
    },
    {
      id: 14,
      name: "Madhya Pradesh",
      path: "madhya-pradesh",
    },
    {
      id: 15,
      name: "Maharashtra",
      path: "maharastra",
    },
    {
      id: 16,
      name: "Manipur",
      path: "manipur",
    },
    {
      id: 17,
      name: "Meghalaya",
      path: "meghalaya",
    },
    {
      id: 18,
      name: "Mizoram",
      path: "mizoram",
    },
    {
      id: 19,
      name: "Nagaland",
      path: "nagaland",
    },
    {
      id: 20,
      name: "Odisha",
      path: "odisha",
    },
    {
      id: 21,
      name: "Punjab",
      path: "punjab",
    },
    {
      id: 22,
      name: "Rajasthan",
      path: "rajasthan",
    },
    {
      id: 23,
      name: "Sikkim",
      path: "sikkim",
    },
    {
      id: 24,
      name: "Tamil Nadu",
      path: "tamil-nadu",
    },
    {
      id: 25,
      name: "Telangana",
      path: "telangana",
    },
    {
      id: 26,
      name: "Tripura",
      path: "tripura",
    },
    {
      id: 27,
      name: "Uttar Pradesh",
      path: "uttar-pradesh",
    },
    {
      id: 28,
      name: "Uttarakhand",
      path: "uttarakhand",
    },
    {
      id: 29,
      name: "West Bengal",
      path: "west-bengal",
    },
    {
      id: 30,
      name: "Andaman and Nicobar Island",
      path: "andaman",
    },
    {
      id: 31,
      name: "Chandigarh",
      path: "chandigarh",
    },
    {
      id: 32,
      name: "Dadra and Nagar Haveli and Daman and Diu",
      path: "dadra-nagar",
    },
    {
      id: 33,
      name: "Ladakh",
      path: "ladakh",
    },
    {
      id: 34,
      name: "Lakshadweep",
      path: "lakshadweep",
    },
    {
      id: 35,
      name: "Jammu and Kashmir",
      path: "jammu-kashmir",
    },
    {
      id: 36,
      name: "Puducherry",
      path: "puducherry",
    },
  ];

  function getTaxData() {
    axios.get(`${Baseurl.baseurl}/go-taxes/tax-get-all`).then((response) => {
      setSpinner(false);
      setTaxes(response.data.taxes);
    })
    .catch((err) => {
      if(err.toString()==="Error: Network Error")
      {
        history.push('/offline')
      }
      else
      {
        history.push('/400')
      }
  })
  }
  useEffect(() => {
    getTaxData();
  }, []);
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
  const submitHandler = (e) => {
    e.preventDefault();
    const artical = {
      StateName: state.toLowerCase(),
      VehicleType: vehicleObject,
    };
    axios
      .post(`${Baseurl.baseurl}/go-taxes/tax-add`, artical)
      .then((response) => {
        if (response.data.status) {
          swal("Tax Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          setVehicleObject([]);
          setVehicleName("");
          setState("");
          setVehicleTax();
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        handleClose();
        getTaxData();
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
  };
  function addVehicle(e) {
    e.preventDefault();
    let tax = Number(vehicleTax);
    const vehicle1 = {
      VehicleName: vehicleName,
      VehicleTaxCommission: tax,
    };
    setVehicleObject(
      (oldArray) => oldArray.concat(vehicle1),
      () => {}
    );
    swal("Added", "Added successfully", "success", {
      showCancelButton: true,
      timer: 1000,
    });
  }
  function updateVehicle(e) {
    e.preventDefault();
    const artical = {
      VehicleType: vehicleObject,
    };
    axios
      .put(
        `${Baseurl.baseurl}/go-taxes/tax-add-perticular-vehicle/${taxId}`,
        artical
      )
      .then((response) => {
        if (response.data.status) {
          swal("Vehicle Updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          setVehicleObject([]);
          setVehicleName("");
          setState("");
          setVehicleTax();
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        handleClose();
        getTaxData();
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
  }
  function updateVehicleTax(e) {
    e.preventDefault();
    let tax = Number(vehicleTax);
    const artical = {
      VehicleName: vehicleName,
      VehicleTaxCommission: tax,
    };
    axios
      .put(
        `${Baseurl.baseurl}/go-taxes/tax-update-perticular-vehicle/${vehicleTypeId}`,
        artical
      )
      .then((response) => {
        if (response.data.status) {
          swal("Vehicle Tax Updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          setVehicleName("");
          setVehicleTax();
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        setShow1(false);
        getTaxData();
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
  }
  function deleteVehicle() {
    const artical = {
      VehicleTypeID: vehicleTypeId,
    };
    axios
      .put(
        `${Baseurl.baseurl}/go-taxes/tax-delete-perticular-vehicle/${taxId}`,
        artical
      )
      .then((response) => {
        if (response.data.status) {
          swal("Vehicle deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        setShow1(false);
        getTaxData();
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
  }
  function DeleteWholeTax() {
    axios
      .put(`${Baseurl.baseurl}/go-taxes/tax-delete-by-id/${taxId}`)
      .then((response) => {
        if (response.data.status) {
          swal("Tax deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        setShow(false);
        getTaxData();
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
  }
  return (
    <Col lg={12}>
      <Modal
        show={show1}
        onHide={() => {
          setShow1(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {deleteStatus ? "Delete Vehicle" : "Update Tax"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {deleteStatus ? (
            <h4>Are you sure! you want to delete Vehicle</h4>
          ) : (
            <form>
              <div className="form-group row">
                <label className="col-lg-5 col-form-label" htmlFor="val-skill">
                  Vehicle Name
                </label>
                <div className="col-sm-8">
                  <select
                    className="form-control"
                    id="val-skill"
                    name="val-skill"
                    required
                    onChange={(event) => {
                      setVehicleName(event.target.value);
                    }}
                  >
                    <option selected="true" disabled="disabled">
                      {vehicleName}
                    </option>
                    {vehicle &&
                      vehicle.map((val) => <option value={val}>{val}</option>)}
                  </select>
                </div>
                <label
                  className="col-lg-5 col-form-label mt-3"
                  htmlFor="val-skill"
                >
                  Vehicle Tax Commission
                </label>
                <div className="col-sm-8">
                  <input
                  onWheel={(e) => e.target.blur()}
                    defaultValue={vehicleTax}
                    type="number"
                    className="form-control"
                    placeholder="Enter Tax Eg:5%"
                    onChange={(e) => setVehicleTax(e.target.value)}
                    required
                  />
                </div>
                <div className="col-sm-2">
                  <button
                    onClick={(e) => {
                      updateVehicleTax(e);
                    }}
                    className="btn btn-primary"
                  >
                    Update
                  </button>
                </div>
              </div>
            </form>
          )}
        </Modal.Body>
        {deleteStatus && (
          <Modal.Footer>
            <Button
              variant="primary"
              onClick={() => {
                deleteVehicle();
              }}
            >
              Yes
            </Button>
          </Modal.Footer>
        )}
      </Modal>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{deleteTax ? "Delete Tax" : "Add Tax"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {deleteTax ? (
            <h4>Are you sure! you want to delete Tax</h4>
          ) : (
            <form>
              <div className="form-group row">
                {!addVehicleStatus && (
                  <div className="col-sm-8">
                    <label>State</label>
                    <select
                      defaultValue={state}
                      className="form-control"
                      id="sel1"
                      onChange={(e) => setState(e.target.value)}
                      required
                    >
                      <option value="">Select State</option>
                      {states.map((d, i) => (
                        <option value={d.name}>{d.name}</option>
                      ))}
                    </select>
                  </div>
                )}
                <label
                  className="col-lg-5 col-form-label mt-3"
                  htmlFor="val-skill"
                >
                  Vehicle Name
                </label>
                <div className="col-sm-8">
                  <select
                    className="form-control"
                    id="val-skill"
                    name="val-skill"
                    required
                    onChange={(event) => {
                      setVehicleName(event.target.value);
                    }}
                  >
                    <option selected="true" disabled="disabled">
                      select Vehicle
                    </option>
                    {vehicle &&
                      vehicle.map((val) => <option value={val}>{val}</option>)}
                  </select>
                </div>
                <label
                  className="col-lg-5 col-form-label mt-3"
                  htmlFor="val-skill"
                >
                  Vehicle Tax Commission
                </label>
                <div className="col-sm-8">
                  <input
                  onWheel={(e) => e.target.blur()}
                    defaultValue={vehicleTax}
                    type="number"
                    className="form-control"
                    placeholder="Enter Tax Eg:5%"
                    onChange={(e) => setVehicleTax(e.target.value)}
                    required
                  />
                </div>
                <div className="col-sm-2">
                  <button
                    onClick={(e) => {
                      addVehicle(e);
                    }}
                    className="btn btn-primary"
                  >
                    add
                  </button>
                </div>
              </div>
              {vehicleObject != "" && (
                <>
                  <table className="table data-table">
                    <thead>
                      <th>
                        <strong>Vehicle Name</strong>
                      </th>
                      <th>
                        <strong>Vehicle Tax</strong>
                      </th>
                    </thead>
                    <tbody>
                      {vehicleObject.map((val) => {
                        return (
                          <tr>
                            <td>{val.VehicleName}</td>
                            <td>{val.VehicleTaxCommission}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <div>
                    <button
                      onClick={(e) => {
                        if (addVehicleStatus) {
                          updateVehicle(e);
                        } else {
                          submitHandler(e);
                        }
                      }}
                      className="btn btn-primary"
                    >
                      Submit
                    </button>
                  </div>
                </>
              )}
            </form>
          )}
        </Modal.Body>
        {deleteTax && (
          <Modal.Footer>
            <Button
              variant="primary"
              onClick={() => {
                DeleteWholeTax();
              }}
            >
              Yes
            </Button>
          </Modal.Footer>
        )}
      </Modal>
      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
          <Card.Title className="text-white">All Taxes</Card.Title>

          <button
            onClick={() => {
              setShow(true);
              setAddVehicleStatus(false);
              setVehicleObject([]);
              setVehicleName("");
              setState("");
              setVehicleTax();
              setDeleteTax(false);
            }}
            className="btn btn-primary "
          >
            Add Tax
          </button>
        </Card.Header>
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table responsive id="myTable" className="text-white">
                <thead>
                  <tr>
                    <th>
                      <strong>SLNO.</strong>
                    </th>
                    <th>
                      <strong> Category</strong>
                    </th>
                    <th>
                      <strong>Vehicle Type Details</strong>
                    </th>
                    <th>
                      <strong></strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {taxes &&
                    taxes.map((tax, i) => (
                      <tr key={tax._id}>
                        <td>{i + 1}</td>
                        <td>{tax.StateName}</td>
                        {tax.VehicleType.map((vehicle) => {
                          return (
                            <>
                              <Table className="text-white">
                                <th>
                                  <strong>Vehicle Name</strong>
                                </th>
                                <th>
                                  <strong>Vehicle Tax</strong>
                                </th>
                                <th>
                                  <strong></strong>
                                </th>
                                <tr>
                                  <td>{vehicle.VehicleName}</td>
                                  <td> {vehicle.VehicleTaxCommission}</td>
                                  <td>
                                    {" "}
                                    <Dropdown>
                                      <Dropdown.Toggle
                                        variant="warning"
                                        className="light sharp i-false"
                                      >
                                        {svg1}
                                      </Dropdown.Toggle>
                                      <Dropdown.Menu>
                                        <Dropdown.Item
                                          onClick={() => {
                                            setShow1(true);
                                            setVehicleName(vehicle.VehicleName);
                                            setVehicleTax(
                                              vehicle.VehicleTaxCommission
                                            );
                                            setVehicleTypeId(vehicle._id);
                                            setDeleteStatus(false);
                                          }}
                                        >
                                          Update
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          onClick={() => {
                                            setShow1(true);
                                            setTaxId(tax._id);
                                            setVehicleTypeId(vehicle._id);
                                            setDeleteStatus(true);
                                          }}
                                        >
                                          Delete
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </td>

                                  <br />
                                </tr>
                              </Table>
                            </>
                          );
                        })}
                        <td className="ml-5">
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="warning"
                              className="light sharp i-false"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  setShow(true);
                                  setVehicleObject([]);
                                  setVehicleName("");
                                  setState("");
                                  setVehicleTax();
                                  setAddVehicleStatus(true);
                                  setTaxId(tax._id);
                                  setDeleteTax(false);
                                }}
                              >
                                Add Vehicle
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  setShow(true);
                                  setDeleteTax(true);
                                  setTaxId(tax._id);
                                }}
                              >
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default Taxes;
